import Vue from 'vue'
import _ from 'lodash'
import moment from 'moment'
import { nanoid } from 'nanoid'
var host = process.env.VUE_APP_API

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    loading: true,
    hotels: [],
    activehotel: {},
    editsegments: false,
    selecthoteldialog: false
  },
  actions: {
    getHotels ({state, commit, rootState}) {
      console.log('getHotels: ')
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .get(host + '/hotels',
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            commit('LOAD_HOTELS', response.data.hotels)
            // state.activehotel?._id ?? commit('SET_ACTIVEHOTEL', state.hotels[0])
            commit('SET_ACTIVEHOTEL', _.find(response.data.hotels, {_id: state.activehotel?._id}) || response.data.hotels[0])
            // state.activehotel = _.find(state.hotels, {_id: state.activehotel._id})
            var privileges
            if (state.activehotel && state.activehotel.user === rootState.user.id) {
                privileges = {
                    owner: true,
                    admin: true
                }
            } else {
                privileges = _.find(rootState.user.profile.hotels, {hotelid: state.activehotel?._id})?.privileges ?? {}
            }
            // this.$store.commit('SET_PRIVILEGES', privileges)
            commit('SET_PRIVILEGES', privileges, {root: true})
            commit('SET_LOADING', false)
            resolve('ok')
            // commit('SET_SELECTHOTELDIALOG', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
        })
    },
    getOwner ({state, rootState, dispatch, commit}) {
      console.log('getOwner: ', state.activehotel.user)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/owner', {id: state.activehotel.user},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            console.log(response.data)
            // commit('SET_ACTIVEHOTEL', response.data.hotel)
            resolve(response.data)
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    addBeach ({state, rootState, dispatch, commit}, data) {
      // console.log('addBeach: ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/addbeach', data,
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            commit('SET_ACTIVEHOTEL', response.data.hotel)
            dispatch('getHotels').then(data => {
              resolve('ok')
            })
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    updateHotel ({state, rootState, dispatch, commit}, hotel) {
      // console.log('updateHotel: ', hotel)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(host + '/hotel/update', { hotel: hotel },
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            dispatch('getHotels')
            commit('SET_ACTIVEHOTEL', hotel)
            commit('SET_LOADING', false)
            resolve('ok')
            // dispatch('ombrelloni/getOmbrelloni', null, {root: true})
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    deleteHotel ({state, rootState, dispatch, commit}) {
      // console.log('deleteHotel: ', state.activehotel)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .delete(host + '/hotel',
          {
            body: { hotel: state.activehotel },
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            commit('SET_ACTIVEHOTEL', {})
            dispatch('getHotels')
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    addSegment ({state, rootState, dispatch, commit}, segment) {
      // console.log('addSegment: ', segment)
      commit('SET_LOADING', true)
      _.forEach(state.activehotel.segments, function (segmento) {
       // console.log(segmento.ombrelloni[0])
       // return _.pullAllBy(segment.ombrelloni, segment.seats, 'ombrelloneid')
       // return _.filter(segmento.ombrelloni, (o) => {
       //  return segment.seats.includes(o.ombrelloneid)
       // })
       // console.log(nanoid())
       return _.remove(segmento.ombrelloni, function (o) {
        // console.log(o.ombrelloneid, o.ombrid)
        // console.log(_.includes(segment.seats, o.ombrelloneid))
        // console.log(_.some(segment.seats, ['ombrelloneid', o.ombrelloneid]))
        // return segment.seats.includes(o.ombrelloneid)
        return _.some(segment.seats, ['ombrelloneid', o.ombrelloneid])
       })
      })
      // console.warn(state.activehotel._id + '_segment_' + nanoid(8))
      var newsegment = {segmentid: state.activehotel._id + '_segment_' + nanoid(8), name: segment.name, ombrelloni: segment.seats, price: '0', color: segment.color}
      state.activehotel.segments.push(newsegment);
      // console.log(state.activehotel.segments)
      return new Promise((resolve, reject) => {
        Vue.http
          // .post(process.env.VUE_APP_API + '/hotel/createsegment', {name: segment.name, seats: segment.seats, hotelid: state.activehotel._id, color: segment.color},
          .post(process.env.VUE_APP_API + '/hotel/createsegment', {hotelid: state.activehotel._id, segments: state.activehotel.segments, newsegment: newsegment},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            resolve('ok')
            dispatch('getHotels')
            commit('SET_LOADING', false)
            // dispatch('getHotels')
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    updateSegments ({state, rootState, dispatch, commit}) {
      // console.log('updateSegments: ', state.activehotel)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/hotel/updatesegment', {hotel: state.activehotel},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    deleteSegments ({state, rootState, dispatch, commit}, segmento) {
      // console.log('deleteSegments: ', state.activehotel.segments, segmento)
      _.remove(state.activehotel.segments, (segment) => {
        return segment.segmentid === segmento.segmentid
      })
      _.map(state.activehotel.seasons, function (season) {
        // console.log(season.name)
        _.map(season.pricelist, function (list) {
          // console.log(list.segments)
          _.remove(list.segments, (segment) => {
            return segment.segmentid === segmento.segmentid
          })
        })
      })
      // console.log(state.activehotel.segments)
      // console.warn('updating segments')
      dispatch('updateSegments')
      // commit('SET_LOADING', true)
      // return new Promise((resolve, reject) => {
      //   Vue.http
      //     .post(process.env.VUE_APP_API + '/hotel/updatesegment', {hotel: state.activehotel},
      //     {
      //       headers: {
      //         'Authorization': 'Bearer ' + rootState.jwt.jwt
      //       }
      //     },
      //     ).then(response => {
      //       console.log(response.data)
      //       resolve('ok')
      //       // dispatch('getHotels')
      //       commit('SET_LOADING', false)
      //     }, error => {
      //       reject(error)
      //       commit('SET_LOADING', false)
      //     })
      // })
    },
    addSeason ({state, rootState, dispatch}, season) {
      console.log('addSeason: ', season, state)
      season.range.start = moment(season.range.start).format('DD.MM.YYYY')
      season.range.end = moment(season.range.end).format('DD.MM.YYYY')
      // console.log(season.range.start)
      if (!state.activehotel.seasons) { state.activehotel.seasons = [] }
      if (state.activehotel.segments.length < 1) {
        dispatch('addSegment', {
          name: 'default',
          seats: _.map(rootState.ombrelloni.ombrelloni, (ombrellone) => {
            return {
              ombrid: ombrellone.ombrid,
              ombrelloneid: ombrellone._id
            }
          }),
          color: '',
          price: season.baseprice.replace(',', '.')
        })
      }
      season.pricelist.push({
        period: '1',
        segments: JSON.parse(JSON.stringify(_.map(state.activehotel.segments, function (o) {
          o.price = isNaN(season.baseprice) ? season.baseprice.replace(',', '.') : season.baseprice
          return _.omit(o, ['color', 'ombrelloni'])
        }))),
        items: JSON.parse(JSON.stringify(_.map(season.items, function (o) {
          o.price = isNaN(o.price) ? o.price.replace(',', '.') : o.price
          return _.omit(o, ['icon', 'num'])
        })))
        // items2: season.items
      })
      _.map(season.items, function (o) {
        if (o.price.length === 0) {
          o.price = '0'
        }
      })
      state.activehotel.seasons.push(season)
      // console.log(season)
      Vue.http
        .post(host + '/addseason', { hotel: state.activehotel, season: season },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          dispatch('getHotels')
        })
    },
    updateSeasons ({state, rootState, dispatch}) {
      _.map(state.activehotel.seasons, function (s) {
        // console.log(s)
        s.range.start = moment(s.range.start, 'DD.MM.YYYY', true).format('DD.MM.YYYY')
        s.range.end = moment(s.range.end, 'DD.MM.YYYY', true).format('DD.MM.YYYY')
        // console.log(s.name, s.range.start, s.range.end)
        return s
      })
      // console.log(state.activehotel)
      Vue.http
        .post(host + '/updateseason', { hotel: state.activehotel },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          dispatch('getHotels')
        })
    },
    removeSeason ({state, rootState, dispatch}, data) {
      // state.activehotel.seasons.splice(data.index, 1)
      // console.log('removeSeason ', data, state.activehotel.seasons)
      Vue.http
        .post(host + '/removeseason', { hotel: state.activehotel, index: data.index, season: data.season },
        {
          headers: {
            'Authorization': 'Bearer ' + rootState.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          dispatch('getHotels')
        })
    },
    updateGrid ({state, rootState, dispatch, commit}, data) {
      // state.activehotel.seasons.splice(data, 1)
      // console.log('updateGrid ', data)
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(host + '/api/grid/update', { ombrelloni: data, hotel: state.activehotel },
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            dispatch('getHotels')
            dispatch('ombrelloni/getOmbrelloni', null, {root: true}).then(() => {
              resolve('ok')
            })
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
    },
    convertItems ({rootState, state, commit}) {
      // console.log('convert: ')
      commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .post(process.env.VUE_APP_API + '/guests/convertitems', {hotel: state.activehotel},
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response.data)
            resolve('ok')
            // dispatch('getHotels')
            commit('SET_LOADING', false)
          }, error => {
            reject(error)
            commit('SET_LOADING', false)
          })
      })
      // Vue.http
      //   .post(process.env.VUE_APP_API + '/guests/convert', rootState.hotels.activehotel,
      //   {
      //     headers: {
      //       'Authorization': 'Bearer ' + rootState.jwt.jwt
      //     }
      //   },
      //   ).then(response => {
      //     // console.log(response.data)
      //     // dispatch('getHotels')
      //   })
    },
    syncSeasons ({state, commit, dispatch}, payload) {
      // console.log('payload ', payload)
      commit('SYNC_SEASONS', payload)
      // dispatch('updateSeasons')
    }
  },
  mutations: {
    SYNC_SEASONS (state, dispatch, data) {
      state.activehotel.seasons = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    LOAD_HOTELS (state, response) {
      state.hotels = response
      state.loading = false
    },
    SET_ACTIVEHOTEL (state, data) {
      // console.log('SET_ACTIVEHOTEL: ', data)
      state.activehotel = data
    },
    RELOAD_ACTIVEHOTEL (state) {
      // console.log(_.find(state.hotels, {_id: state.activehotel._id}))
      // console.warn('RELOAD_ACTIVEHOTEL')
      // state.activehotel = _.find(state.hotels, {_id: state.activehotel._id})
    },
    SET_EDITSEGMENTS (state, data) {
      state.editsegments = data
    },
    SET_SELECTHOTELDIALOG (state, data) {
      state.selecthoteldialog = data
    }
  },
  getters: {
    activehotel: state => {
      return state.activehotel
    }
  }
}
